import React from 'react';
import { Icon } from './Icon.js';
export const IconLineChartDown = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2.5 13L9.06666 19.5667L14.9333 13.8524L21.5 20.4191", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M17 3L18.712 6L19 6H19.288L21 3L17 3Z", fill: "currentColor", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square" })));
};
//# sourceMappingURL=IconLineChartDown.js.map